export default __webpack_public_path__ + "static/media/Slide1.fa669f2a.svg";